import React, { lazy } from 'react';
import { Switch, Route } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';
const GstInData = lazy(() => import('./gst-in/GstInData'));

const GstIn = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={`${path === '/' ? '' : path}/list`} component={GstInData} />
    </Switch>
  );
};

export default GstIn;
